import { useRef } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { QRCodeSVG } from "qrcode.react";
import logo from "../../../../../images/logo.svg";

const QRModal = ({ modal, setModal, item, setShouldUpdate }) => {
	const qrRef = useRef();
	const lang = useSelector((state) => state.auth.lang);

	const print = () => {
		const svg = qrRef.current.querySelector("svg");
		const svgData = new XMLSerializer().serializeToString(svg);
		const imgData = "data:image/svg+xml;base64," + btoa(svgData);
		const printWindow = window.open("", "_blank");

		let htmlCode = `
			<html>
				<head>
					<meta charset="UTF-8">
					<meta name="viewport" content="width=device-width, initial-scale=1.0">
					<title>Payment</title>
				</head>
				<body style="margin: 0; padding: 0">
					<div style="display: flex; justify-content: space-between; margin-top: 1.5rem; padding: 0 4rem;">
						<label>Scan:</label>
						<label>
							${Translate[lang]?.login_number}: 
							<span style="color: #b87332">${item?.login_number}</span>
						</label>
					</div>

					<div style="margin-top: 3.5rem; padding: 0 4rem;">
						<span style="font-size: 20px">${item?.number}</span>
					</div>
					<div style="text-align: center; margin-top: .5rem; padding: 0 4rem;">
						<img src="${logo}" style="width:130px;height:130px;" />
					</div>

					<div style="text-align: center; margin-top: 2.5rem">
						<img src="${imgData}" style="width:400px;height:400px" />
					</div>

					<div style="text-align: center; margin-top: 4.5rem">
					للاستفسار والدعم : 97009317 - 97009316
					</div>
				</body>
			</html>
		`;
		printWindow.document.write(htmlCode);
		printWindow.document.close();

		setTimeout(() => {
			printWindow.print();
		}, 1500);
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addQuick" : "ar fade addQuick"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<Modal.Body>
				<Row>
					<Col md={12} className="mb-4">
						<div className="d-flex justify-content-between">
							<p
								className="mb-0"
								style={{
									fontWeight: "600",
									color: "#333",
									fontSize: "20px",
								}}>
								{Translate[lang]?.qr_code}
							</p>
							<Button
								variant=""
								className="close"
								style={{
									right: lang === "en" ? "0" : "auto",
									left: lang === "ar" ? "0" : "auto",
								}}
								onClick={() => {
									setModal();
								}}>
								<span style={{ fontSize: "22px" }}>&times;</span>
							</Button>
						</div>
					</Col>
					<Col md={12}>
						<div className="d-flex justify-content-between">
							<label className="text-label d-block ">Scan:</label>
							<label className="text-label d-block">
								{Translate[lang]?.login_number}:{" "}
								<span className="text-primary">{item?.login_number}</span>
							</label>
						</div>
						<label className="text-start fs-20 text-label">
							{item?.number}:
						</label>
						<div className="text-center" ref={qrRef}>
							<img
								src={logo}
								alt="logo"
								className="d-block m-auto"
								width={120}
								height={80}
							/>
							<QRCodeSVG
								value={"https://fm-dashboard-three.vercel.app"}
								size={250}
								renderAs="canvas"
							/>
						</div>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<div
					className="w-100 d-flex justify-content-between"
					style={{ gap: "24px" }}>
					<Button
						variant="danger"
						onClick={() => {
							setShouldUpdate((prev) => !prev);
							setModal();
						}}
						type="button"
						className="w-100">
						{Translate[lang]?.close}
					</Button>
					<Button
						variant="primary"
						onClick={() => print()}
						type="button"
						className="w-100">
						{Translate[lang]?.print}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default QRModal;
